<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-segment-create v-if="showModal === 'create'" @created="onSegmentCreated" />
            <v-modal-segment-sync-all v-if="showModal === 'sync'" />
        </transition>

        <v-page-header title="Segments" icon="fas fa-chart-pie" />

        <v-page-filters>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getSegments" />
            <v-button-toolbar>
                <v-button size="sm" btn-style="white" @click.native="$store.commit('showModal', 'sync')">Sync All Segments</v-button>
                <v-button size="sm" @click.native="createSegment">Create Segment</v-button>
            </v-button-toolbar>
        </v-page-filters>

        <v-page-body>

            <v-notice v-if="empty" :title="'No Segments Found'" :message="'Create a segment to send targeted campaigns to your customers.'">
                <template #footer>
                    <v-button @click.native="createSegment">Create Segment</v-button>
                </template>
            </v-notice>

            <v-list v-else>
                <v-segment v-for="segment in segments"
                    :key="segment.id"
                    :segment="segment"
                    @synced="getSegments"
                    @duplicated="getSegments"
                    @deleted="getSegments">
                </v-segment>
            </v-list>

        </v-page-body>

    </v-page>

</template>

<script>

import ModalSegmentCreate from '@modals/segment/ModalSegmentCreate';
import ModalSegmentSyncAll from '@modals/segment/ModalSegmentSyncAll';
import Segment from './components/Segment';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-segment-create': ModalSegmentCreate,
        'v-modal-segment-sync-all': ModalSegmentSyncAll,
        'v-segment': Segment,
    },

    data() {
        return {
            segments: [],
            params: {},
        }
    },

    mounted() {
        this.getSegments();
    },

    computed: {

        empty() {
            return this.segments.length === 0;
        },

    },

    methods: {

        onSegmentCreated(id) {
            this.$router.push({
                name: 'segments-edit',
                params: { id: id },
            });
        },

        getSegments() {
            this.$store.commit('loading', true);
            ProjectApi.getSegments(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.segments = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        createSegment() {
            this.$store.commit('showModal', 'create');
        },

    }

}

</script>